export default {
  pageTitle: 'Limited-Time Deal Management',
  region: 'Region',
  radio1: 'All',
  radio2: 'On-going',
  radio3: 'Pending Review',
  radio4: 'Rejected',
  radio5: 'Expired',
  timeLimit: 'Time limit',
  radio6: '1 day (24 hours)',
  radio7: '2 days',
  radio8: '3 days',
  radio9: '5 days',
  radio10: '7 days',
  radio15: '15 days',
  radio30: '30 days',
  applyTime: 'Apply time',
  placeholder1: 'Listing#',
  placeholder2: 'Sku#',
  btn1: '批量操作',
  btn2: '批量下架',
  btn3: '批量再报',
  // -----------------
  auditStatus1: '待审核',
  auditStatus2: '未通过',
  auditStatus3: 'Ongoing',
  auditStatus4: '已失效',
  columns1: 'Listing ID',
  columns2: 'Sku#',
  columns3: 'Sku Title',
  columns4: 'Sale price',
  columns5: 'Deal Price',
  columns6: 'Apply time',
  columns7: 'Review time',
  columns8: 'Time limit',
  columns9: 'Expire date',
  columns10: 'Status',
  columns11: 'Operation',
  renderBtn1: '编辑',
  renderBtn2: '取消',
  renderBtn3: '下架',
  renderBtn4: '再报',
  confirmTitle1: '确定取消操作吗？',
  confirmTitle2: '确定下架吗？',
  confirmTitle3: '确定批量下架吗？',
  confirmTitle4: '确定批量再报吗？',
  okText: '确定',
  cancelText: '取消'
}
